<div class="customizer-links" [ngClass]="{'open': layoutServices.customize != '' }">
    <div class="flex-column nac-pills nav" id="c-pills-tab">
        <a class="nav-link" id="c-pills-home-tab" [ngClass]="{'active': layoutServices.customize == 'layout' }"
           (click)="customizes('layout')">
            <div class="settings">
                <img src="assets/images/customizer/setting-2.png" alt="">
            </div>
            <span>Configurar tabla</span>
        </a>
        <!--<a class="nav-link">
            <div>
                <img src="assets/images/customizer/brush.png" alt="">
            </div>
            <span>Color Picker</span>
        </a>-->
    </div>
</div>

<div class="customizer-contain" [ngClass]="{'open': layoutServices.customize != '' }">
    <div class="tab-content" id="c-pills-tabContent">
        <div class="customizer-header">
            <i class="icofont-close icon-close" (click)="customizes('')"></i>
            <h5>Preview Settings</h5>
            <p class="mb-0">Try It Real Time<i class="fa fa-thumbs-o-up txt-primary"></i>
                <ng-template #popup let-modal>
                    <div class="modal-header modal-copy-header">
                        <h5 class="headerTitle mb-0">Customizer configuration</h5>
                        <button type="button" class="btn-close" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="modal-body config-popup">
                            <div class="row">
                                <p>To replace our design with your desired theme. Please do configuration as mention
                                </p>
                                <p> <b> Path : src > app > shared > services > layoutService.service.ts </b> </p>
                            </div>
                        </div>
                        <button class="btn btn-primary mt-2 me-2">Copy
                            Json</button>
                        <button class="btn btn-primary mt-2" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">Close</button>
                    </div>
                </ng-template>
            </p>
            <button class="btn btn-primary plus-popup mt-2">Configuration</button>
        </div>
        <div class="custom-scrollbar customizer-body">

        </div>
    </div>
</div>
